import {
  GET_LICENSES_REQUEST,
  GET_LICENSES_SUCCESS,
  GET_LICENSES_FAILURE,
  GET_TRACK_USAGE_REQUEST,
  GET_TRACK_USAGE_SUCCESS,
  GET_TRACK_USAGE_FAILURE,
} from '../constants/settingConstants';

const initialState = {
  licenses: [],
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
  trackUsage: [],
  trackUsageLoading: false,
  trackUsageError: null,
  trackUsagePagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
};

const settingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LICENSES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_LICENSES_SUCCESS:
      return {
        ...state,
        loading: false,
        licenses: action.payload.response || [],
        pagination: action.payload.pagination || {
          currentPage: 1,
          totalPages: 1,
          totalItems: 0,
          itemsPerPage: 10,
        },
        error: null,
      };
    case GET_LICENSES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        licenses: [],
      };
    case GET_TRACK_USAGE_REQUEST:
      return {
        ...state,
        trackUsageLoading: true,
        trackUsageError: null,
      };
    case GET_TRACK_USAGE_SUCCESS:
      return {
        ...state,
        trackUsageLoading: false,
        trackUsage: action.payload.data || [],
        trackUsagePagination: action.payload.pagination || {
          currentPage: 1,
          totalPages: 1,
          totalItems: 0,
          itemsPerPage: 10,
        },
        trackUsageError: null,
      };
    case GET_TRACK_USAGE_FAILURE:
      return {
        ...state,
        trackUsageLoading: false,
        trackUsageError: action.payload,
        trackUsage: [],
      };
    default:
      return state;
  }
};

export default settingReducer;